/*
 * @Author: LZT
 * @Date: 2024-12-17 09:30:20
 * @LastEditors: LZT
 * @Description:
 */
import Layout from "@/Layout";
export default [
  {
    path: "/optional",
    component: Layout,
    children: [
      {
        path: "opt-stock",
        component: () => import("@/views/gnPage/optional/optional-stock.vue"),
        name: "OptStock",
        meta: {
          title: "自选股",
          keepAlive: true,
          showFooter: true,
          showHead: true,
          showRight: true
        }
      },
      {
        path: "pdf-details",
        name: "PdfDetails",
        component: () => import("@/views/gnPage/information/pdf-details.vue"),
        meta: {
          title: "PDF详情",
          keepAlive: false,
          showHead: false,
          showLeft: false
        }
      }
    ]
  }
];
